<template>
  <AddNote/>
</template>

<script>
import AddNote from "./AddNote";
export default {
  name: "EditNote",
  components:{
    AddNote
  }
}
</script>
